// NPM
import { graphql } from "gatsby"
import _ from "lodash"
import * as React from "react"

// Components
import Signup from "src/components/pages/Signup/Signup"
import Layout from "src/layouts/en"

const SignupPageEn = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `signupPage.sections`, [])
  const signupForm = _.get(data, `signupForm`)
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.signupPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Signup sections={sections} signupForm={signupForm} lang="en" />
    </Layout>
  )
}

export default SignupPageEn

export const query = graphql`
  query SignupPageEnQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "en" }) {
      ...topNavContent
    }

    signupPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    signupForm: strapiSignupForm(locale: { eq: "en" }) {
      fields: strapi_fields {
        uuid
        strapi_component
        placeholder
        order
        name
      }

      submitText
    }

    testimonials: allStrapiTestimonial(filter: { locale: { eq: "en" } }) {
      nodes {
        name
        quote
        credit
        order
      }
    }

    bottomNav: strapiBottomNav(locale: { eq: "en" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "en" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
